// Módulo Turmas: cursos e turmas + alunos/avisos de uma turma.
import { frontendURL } from '../../../helper/URLHelper';

const CoursesIndex = () => import('./CoursesIndex.vue');
const CourseStudents = () => import('./CourseStudents.vue');
const CourseInterested = () => import('./CourseInterested.vue');
const CourseClassShow = () => import('./CourseClassShow.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/turmas'),
    name: 'courses_index',
    meta: { permissions: ['administrator', 'agent'] },
    component: CoursesIndex,
  },
  {
    path: frontendURL('accounts/:accountId/turmas/alunos'),
    name: 'courses_students',
    meta: { permissions: ['administrator', 'agent'] },
    component: CourseStudents,
  },
  {
    path: frontendURL('accounts/:accountId/turmas/interessados'),
    name: 'courses_interested',
    meta: { permissions: ['administrator', 'agent'] },
    component: CourseInterested,
  },
  {
    path: frontendURL('accounts/:accountId/turmas/:classId'),
    name: 'course_class_show',
    meta: { permissions: ['administrator', 'agent'] },
    component: CourseClassShow,
    props: route => ({ classId: Number(route.params.classId) }),
  },
];
